import { fade, makeStyles } from "@material-ui/core/styles";
import { indigo } from "@material-ui/core/colors";

export default makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    display: "flex",
    flexDirection: "column",
  },
  scroll: {
    height: 0,
    flexGrow: 1,
    width: "100%",
    backgroundColor: "#FFF",
  },
  listSection: {
    backgroundColor: "inherit",
  },
  ul: {
    backgroundColor: "inherit",
    padding: 0,
  },
  appBar: {
    color: theme.palette.getContrastText(indigo[500]),
    backgroundColor: "#232f3e",
    width: "100%",
    zIndex: 99999,
  },
  toolBarMenu: {
    zIndex: "999999 !important",
  },
  grow: {
    flexGrow: 1,
  },
  toolbar: {
    paddingLeft: theme.spacing(2),
  },
  search: {
    position: "relative",
    borderRadius: theme.shape.borderRadius,
    backgroundColor: fade(theme.palette.common.white, 0.15),
    "&:hover": {
      backgroundColor: fade(theme.palette.common.white, 0.25),
    },
    marginLeft: 0,
    paddingLeft: 0,
  },
  searchIcon: {
    padding: theme.spacing(0, 2),
    height: "100%",
    position: "absolute",
    pointerEvents: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  inputRoot: {
    color: "inherit",
  },
  inputInput: {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
    transition: theme.transitions.create("width"),
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      width: "12ch",
      "&:focus": {
        width: "18ch",
      },
    },
  },
  empty: {
    backgroundColor: "#FFF",
    height: "100%",
    padding: theme.spacing(4),
    textAlign: "center",
  },
  title: {
    maxWidth: theme.spacing(32),
  },
}));
